<template>
  <page>
    <header style="font-size: 24px;text-align: center;">Persónuverndarstefna</header>
    <tabs>
      <tab name="Íslenska">
        <div style="margin-top: -30px; margin-bottom: 30px;" v-if="terms.length > 1">
          <v-select id="selectedTermIs" name="selectedTermIs" v-model="selectedTerm" :clearable="false" :options="terms" label="label_is"> </v-select>
        </div>
        <div v-html="selectedTerm.skilmalar"></div>
      </tab>
      <tab name="English">
        <div style="margin-top: -30px; margin-bottom: 30px;" v-if="terms.length > 1">
          <v-select id="selectedTermEn" name="selectedTermEn" v-model="selectedTerm" :clearable="false" :options="terms" label="label_ens"> </v-select>
        </div>
        <div v-html="selectedTerm.skilmalar_ens"></div>
      </tab>
    </tabs>
  </page>
</template>

<script>
import config from '../services/config'
import moment from 'moment'

export default {
  name: 'access',
  data() {
    return {
      loading_terms: false,
      lang: 'is',
      terms: [],
      selectedTerm: ''
    }
  },
  methods: {
    loadTerms() {
      this.loading_terms = true
      this.$http.get(config.TERM_LIST).then(
        response => {
          this.loading_terms = false
          this.terms = response.data
          this.terms.forEach(e => {
            if (e.dags_til) {
              this.$set(e, 'label_is', `Í gildi ${moment(e.dags_fra).format('DD.MM.YYYY')} - ${moment(e.dags_til).format('DD.MM.YYYY')}`)
              this.$set(e, 'label_ens', `Valid between ${moment(e.dags_fra).format('DD.MM.YYYY')} and ${moment(e.dags_til).format('DD.MM.YYYY')}`)
            } else {
              this.$set(e, 'label_is', 'Núverandi')
              this.$set(e, 'label_ens', 'Current')
            }
          })
          this.selectedTerm = response.data.find(x => x.gildi === 1)
        },
        err => {
          this.loading_terms = false
          alert('Óvænt villa (' + err.status + ') kom upp. Vinsamlegast reyndu aftur.')
        }
      )
    },
    selectLang(lang) {
      this.lang = lang
    }
  },
  created() {
    this.loadTerms()
  }
}
</script>
